export type RepeatBookingInput = Pick<Booking, 'hotel' | 'pack_hours' | 'hour'>

/**
 * Construye la URL de ficha de hotel para repetir una reserva pasada.
 * Pre-rellena pack, hora (flujo control) y scroll a habitaciones.
 */
export function useRepeatBooking() {
  const { locale } = useI18n()
  const { isPackFirstFlow } = useCheckoutFlowExperiment()

  function getRepeatBookingUrl(booking: RepeatBookingInput): string {
    const hotel = booking.hotel
    const slug = hotel?.slug || slugify(hotel?.name || 'hotel')
    const hotelId = hotel?.id
    const params = new URLSearchParams()

    if (booking.pack_hours) {
      params.set('pack', String(booking.pack_hours))
    }
    if (!isPackFirstFlow.value && booking.hour) {
      params.set('hora', booking.hour)
    }
    params.set('scrollTo', 'seccion_habitaciones')

    const query = params.toString()
    return `/${locale.value}/${slug}-${hotelId}.html${query ? `?${query}` : ''}`
  }

  return { getRepeatBookingUrl }
}
